import 'css-chunksrc/client/pages/costProfilesPage/styles.scss';export default {
  "costProfilesPage": "_costProfilesPage_mxnv0_1",
  "header": "_header_mxnv0_9",
  "profileNavigation": "_profileNavigation_mxnv0_19",
  "title": "_title_mxnv0_27",
  "menu": "_menu_mxnv0_33",
  "main": "_main_mxnv0_40",
  "sidebar": "_sidebar_mxnv0_45",
  "content": "_content_mxnv0_56",
  "resourcesList": "_resourcesList_mxnv0_66",
  "heading": "_heading_mxnv0_73",
  "label": "_label_mxnv0_81",
  "loader": "_loader_mxnv0_92",
  "loaderMain": "_loaderMain_mxnv0_101"
};